import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { LottieShipWindow } from 'Views/Components/_HumanWritten/Lottie/LottieShipWindow';
import { SteeringWheelSpinner } from 'Views/Components/_HumanWritten/Lottie/SteeringWheelSpinner';
import classNames from 'classnames';

interface PostPaymentRenderProps {
	className?: string;
}

export function PostPaymentRender({ className }: PostPaymentRenderProps) {
	// This is a different component because we also render it on the payment screen when the user has submitted their
	// payment
	return (
		<div className={classNames('post-payment__wrap', className)}>
			<SteeringWheelSpinner postPayment />
			<h2 className="post-payment__header">
				<FormattedMessage id="booking-wizard__post-payment__header" defaultMessage="Hold tight!" />
			</h2>
			<h5 className="post-payment__subheader">
				<FormattedMessage
					id="booking-wizard__post-payment__subheader"
					defaultMessage="Your payment is being processed"
				/>
			</h5>
			<p className="post-payment__text">
				<FormattedMessage
					id="booking-wizard__post-payment__description"
					defaultMessage="<strong>Do not exit this page</strong> until your payment has been confirmed. If you do not see the confirmation message and you have not received your confirmation email after 10 minutes please contact us."
					values={{ strong: (chunks: React.ReactNode) => <strong>{chunks}</strong> }}
				/>
			</p>
		</div>
	);
}
